import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import { eventCashFlowInitialValues, IEventCashFlowForm } from 'components/organisms/forms/event-cash-flow/EventCashFlowForm';
import { FormikHelpers } from 'formik';
import { useCustomParamId } from 'hooks/useParamId';
import { eventCashFlowFormToUpdateQuery, eventCashFlowQueryToForm } from 'middleware/event-cash-flow';
import { useTranslation } from 'react-i18next';
import { PiHandCoinsBold, PiX } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { useGetEventIncome, useUpdateEventIncome } from 'services/events/income';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

const EditEventIncome = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const eventIncomeId = useCustomParamId('eventIncomeId');
  
  const updateEventIncome = useUpdateEventIncome();
  const { data: eventIncome, isLoading } = useGetEventIncome(eventIncomeId);

  const onEditEventIncome = async (
    values: IEventCashFlowForm,
    helpers: FormikHelpers<IEventCashFlowForm>
  ) => {
    if (!eventIncome) return;
    
    const eventIncomeData = eventCashFlowFormToUpdateQuery(values, 'income', eventIncome.id, eventIncome.version) as any;
    
    await updateEventIncome.mutateAsync(eventIncomeData, {
      onSuccess: () => {
        helpers.setSubmitting(false);
        navigate(`/event/${eventIncome.eventId}/income/${eventIncomeId}`);
      },
      onError: () => {
        helpers.setSubmitting(false);
      },
    });
  };

  return (
    <Form.EventCashFlow
      i18nextPrefix='event-income'
      initialValues={
        eventIncome ? eventCashFlowQueryToForm(eventIncome, 'income') : eventCashFlowInitialValues
      }
      onSubmit={onEditEventIncome}
      status={{ isLoading }}
      customBackItem={
        <Button 
          type='button' 
          onlyIcon 
          onClick={() => navigate(`/event/${eventIncome?.eventId}/income/${eventIncomeId}`)}
        >
          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <Button type='submit' variant={BUTTON_VARIANT.submit}>
          <Button.Text text={t('button.save')} />
          <Button.Icon icon={<PiHandCoinsBold />} />
        </Button>
      }
    />
  );
};

export default EditEventIncome; 